import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  DialogBody,
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerBody,
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import LinkedInAccountFormField from "../LinkedInAccountFormField";
import EventFormField from "./EventFormField";
import SelectedEvent from "./SelectedEvent";

import type {
  LinkedInEvent as Event,
  EventLeadListSource,
} from "../../../../types";

import EventImage from "assets/images/sources/event.png";

interface LinkedInEventProps {
  accountId: string;
  setAccountId: (accountId: string) => void;
  createSource: (settings: EventLeadListSource["settings"]) => void;
  isCreatingSource: boolean;
  goBack: () => void;
}

export default function LinkedInEvent({
  accountId,
  setAccountId,
  createSource,
  isCreatingSource,
  goBack,
}: LinkedInEventProps) {
  const isDesktop = useTwBreakpoint("lg");
  const [selectedEvent, setSelectedEvent] = useState<Event>();

  function addLeads() {
    createSource({ type: "event", event_id: selectedEvent.id });
  }

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Body = isDesktop ? DialogBody : DrawerBody;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  return (
    <>
      <Header
        title="Event attendees"
        onBack={selectedEvent ? () => setSelectedEvent(undefined) : goBack}
      />
      <Body className="gap-y-3 lg:gap-y-6">
        {selectedEvent ? (
          <SelectedEvent accountId={accountId} event={selectedEvent} />
        ) : (
          <>
            <div className="flex gap-3 lg:gap-5 max-lg:order-3 flex-col lg:flex-row-reverse">
              <LinkedInAccountFormField
                accountId={accountId}
                setAccountId={setAccountId}
              />
              <EventFormField
                accountId={accountId}
                onSelect={setSelectedEvent}
              />
            </div>

            <img src={EventImage} alt="" height={238} />
          </>
        )}
      </Body>

      {selectedEvent && (
        <Footer className="justify-between">
          <Close asChild>
            <Button variant="secondary-black">Cancel</Button>
          </Close>
          <Button
            onClick={addLeads}
            disabled={!selectedEvent}
            isLoading={isCreatingSource}
          >
            Add leads
          </Button>
        </Footer>
      )}
    </>
  );
}
